<template>
  <div class="mask-container" v-if="visible">
    <div class="back-container" v-if="!isUploadSuccess">
      <div class="progress">
        <el-progress :width="120" type="circle" :percentage="progressPercent"></el-progress>
      </div>
      <div class="title">{{ title || "上传中..." }}</div>
      <div class="info">{{ info || "文件上传中，请耐心等待。" }}</div>
    </div>
    <div class="back-container" v-else>
      <div class="success-icon">
        <!-- <img
          :src="require('@teacherB/common/popup/success.png')"
          alt=""
        /> -->
      </div>
      <div class="title success-title">{{ successTitle ||  '上传成功！' }}</div>
      <div class="success-button">
        <el-button type="primary" @click="submitEvent">确定</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['title', 'info', 'successTitle', 'visible', 'progressPercent', 'isUploadSuccess'],
  created() {},
  methods: {
    submitEvent() {
      this.$emit('successHandle')
    }
  }
}
</script>

<style lang="scss" scoped>
  .mask-container{
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0 , 0, 0.45);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999999;

    .back-container{
      width: 300px;
      height: 300px;
      background: #fff;
      border-radius: 8px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      .progress{
        width: 120px;
        margin: 48px auto 0;
      }

      .title{
        font-size: 18px;
        line-height: 24px;
        color: #2D3043;
        text-align: center;
        margin-top: 31px;
        font-weight: bold;
      }

      .info{
        font-size: 14px;
        line-height: 24px;
        color: #808290;
        text-align: center;
        margin-top: 15px;
      }

      .success-icon{
        width: 80px;
        height: 80px;
        margin: 46px auto 0;

        img{
          width: 80px;
          height: 80px;
        }
      }

      .success-title{
        margin-top: 36px;
      }

      .success-button{
        width: 100px;
        margin: 36px auto 0;
        text-align: center;
      }
    }
  }
</style>